import ultravioletPrinting from "./templates/ultraviolet-printing";

export default [
  {
    id: `description`,
    title: `О товаре`,
  },
  {
    id: `material`,
    title: `Качество материала`,
    content: {
      description: `
        <p>
          Термос выполнен в сдержанном классическом дизайне. 
          Подойдёт как для официальных мероприятий, так и для повседневного использования. 
          Благодаря покрытию soft-touch удобно и надёжно лежит в руке. 
          Имеется съёмное ситечко.<br>Объём 420 мл.
        </p>
      `
    }
  },
  {
    id: `printing`,
    title: `Способ печати`,
    content: {
      printingInfo: `${ultravioletPrinting}`
    }
  },
  {
    id: `price`,
    title: `Цены`
  },
  {
    id: `delivery`,
    title: `Доставка и оплата`
  },
  {
    id: `reviews`,
    title: `Отзывы`
  }
];
